let _labelsCatalog = null;
let _labelsCatalogPromise = null;

function labelsNormalizeLanguage(language) {
  return language === "es" ? "es" : "ca";
}

function labelsBuildTextMap(catalog) {
  const map = new Map();
  const labels = catalog && Array.isArray(catalog.labels) ? catalog.labels : [];
  labels.forEach((label) => {
    if (!label || !label.value) {
      return;
    }
    map.set(label.value, label.text || {});
  });
  return map;
}

function labelsFetchCatalog() {
  if (_labelsCatalogPromise) {
    return _labelsCatalogPromise;
  }

  _labelsCatalogPromise = fetch("/labels/v2")
    .then((response) => {
      if (!response.ok) {
        throw new Error("HTTP " + response.status);
      }
      return response.json();
    })
    .then((catalog) => {
      _labelsCatalog = labelsBuildTextMap(catalog);
      labelsHydratePosterLabels(document);
      return _labelsCatalog;
    })
    .catch((error) => {
      console.log("Labels catalog fetch error: ", error);
      return null;
    });

  return _labelsCatalogPromise;
}

function labelsGetDisplayLabel(value, language) {
  const normalizedLanguage = labelsNormalizeLanguage(language);
  const text = _labelsCatalog ? _labelsCatalog.get(value) : null;
  if (!text) {
    return value;
  }
  return text[normalizedLanguage] || text.ca || value;
}

function labelsHydratePosterLabels(root = document) {
  if (!root || !_labelsCatalog) {
    return;
  }

  const labels = root.querySelectorAll("[data-label-value][data-label-language]");
  labels.forEach((element) => {
    const value = element.getAttribute("data-label-value") || "";
    const language = element.getAttribute("data-label-language") || "ca";
    element.textContent = labelsGetDisplayLabel(value, language);
  });
}

labelsFetchCatalog();

export {
  labelsFetchCatalog,
  labelsGetDisplayLabel,
  labelsHydratePosterLabels
};
